import { globalCss } from './createStitchesStyle';

export const globalStyles = globalCss({
  '@import': [
    "url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;400;500;600;700;800&family=Rubik+Microbe&display=swap')",
  ],

  '@font-face': [
    {
      fontFamily: 'Poppins',
      src: "url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;400;500;600;700;800&family=Rubik+Microbe&display=swap')",
    },
  ],

  '*': {
    margin: '0',
    padding: '0',
    outline: '0',
    boxSizing: 'border-box',

    fontFamily: "'Poppins', sans-serif",
  },

  ':root, html': {
    fontSize: '62.5%',
  },

  html: {
    overflow: 'hidden',
  },

  body: {
    backgroundColor: '$background',
  },

  'html, body': {
    height: '100vh',
    textRendering: 'optimizeLegibility',
  },

  'button, a': {
    cursor: 'pointer',
  },
});
